import { component } from 'picoapp';
import Drawer from 'utils/drawer';

export default component(async (node) => {
  const headerWrapper = document.querySelector('.header--wrapper');
  const closeButton:HTMLElement = node.querySelector('[data-close]');
  const backButton:HTMLElement = node.querySelector('[data-back]');
  const drawer = Drawer(node);
  const openButtons = document.querySelectorAll('[data-open="mobile-navigation"]');

  const openSubMenuButtons:NodeListOf<HTMLElement> = node.querySelectorAll('[data-open-menu]');
  const subMenuList:NodeListOf<HTMLElement> = node.querySelectorAll('[data-menu]');

  openSubMenuButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const subMenu = button.dataset.openMenu;
      const subMenuElement:HTMLElement = node.querySelector(`[data-menu="${subMenu}"]`);

      subMenuElement.hidden = false;
      backButton.hidden = false;
    });
  });

  const resetMenu = () => {
    backButton.hidden = true;
    subMenuList.forEach((menu) => {
      const scrolledElement = menu.querySelector('[data-scroll-lock-scrollable]');
      scrolledElement.scrollTop = 0;
      menu.hidden = true;
    });
  };

  backButton.addEventListener('click', () => {
    resetMenu();
  });

  closeButton.addEventListener('click', () => {
    drawer.close();
  });

  openButtons.forEach((button) => {
    button.addEventListener('click', () => {
      drawer.open();
    });
  });

  drawer.on('open', async () => {
    const disableScroll = (await import(
      /* webpackChunkName: "scroll-lock" */
      'modules/scroll-lock'
    )).default.disablePageScroll;
    disableScroll(node);

    headerWrapper.setAttribute('data-open', 'true');
  });

  drawer.on('closed', async () => {
    const enableScroll = (await import(
      /* webpackChunkName: "scroll-lock" */
      'modules/scroll-lock'
    )).default;

    enableScroll.clearQueueScrollLocks();
    enableScroll.enablePageScroll(node);

    headerWrapper.setAttribute('data-open', 'false');

    resetMenu();
  });
});
